import Config from '@app/dev/config/main';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';

class DepositServicePix {
  static async createOrder(amount) {
    try {
      const req = {
        amount: +amount,
        service: Config.depositeServiceID,
        payer: {
          forProduct: 'sport',
        },
      };

      const res = await swarmRequest(req, 'deposit_v2');

      if (res.status === 'error') return { errorText: 'Something went wrong while getting qr code' };

      return { forwardUrl: res.action };
    } catch {
      return { errorText: 'Something went wrong' };
    }
  }
}

export default DepositServicePix;
